export const chatbot = {
   p1: `Configurez votre assistant virtuel`,
   p2: `Activez le service de chatbot pour répondre automatiquement aux questions les plus fréquentes de vos clients.`,
   p3: `Configurez votre assistant virtuel. Personnalisez les réponses de votre chatbot pour fournir des informations rapides et précises à vos clients. Résolvez automatiquement leurs demandes les plus fréquentes.`,
   p4: `Configurer`,
   p5: `Assistant virtuel activé avec succès`,
   p6: `Assistant virtuel désactivé`,

   p7: `Configurez les réponses du ChatBot`,
   p8: `Hébergement assigné :`,
   p9: `Personnalisez les réponses automatiques du chatbot pour traiter efficacement les questions les plus fréquentes de vos clients.`,

   p10: `Vous avez des modifications non enregistrées. Voulez-vous les abandonner et changer de question ?`,

   p11: `Question :`,
   p12: `Inclure une image dans votre réponse`,
   p13: `Téléverser une image`,
   p14: `Supprimer l'image`,
   p15: `Enregistrer la réponse`,
   p16: `Réponse enregistrée avec succès`,
   p17: `Une erreur s'est produite lors de l'enregistrement de la réponse.`,

   p18: `Une erreur s'est produite lors de la suppression de l'image.`,
   p19: `Rédigez votre réponse...`,

   p20: `Bloc de réponse`,
   p21: `Aperçu`,
   p22: ``,
   p23: ``,
   p24: ``,
   p25: ``,
   p26: ``,
   p27: ``,
   p28: ``,
   p29: ``,
   p30: ``,
}